import { useConfig } from '../../context/ConfigProvider/ConfigProvider';
export const useIsOpenTestAttribute = (isError) => {
    const { isOpenTestAttributeName } = useConfig();
    return { [isOpenTestAttributeName]: isError };
};
